export function getGraphicalMapRuntimeScale(mapId: string): [number, number, number] {
  switch (mapId) {
    // The shipped de_outpost GLB is authored with Z mirrored relative to the
    // server/runtime coordinate space used across gameplay, collision, and PVS.
    case 'de_outpost':
    case 'de_outpost_v6':
      return [1, 1, -1];
    default:
      return [1, 1, 1];
  }
}
